
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { dataSource_tonghaoV2 } from '@xt/client/dataSource/kindred-spirit'
import { Observer } from 'mobx-vue'
import MomentCard from './components/MomentCard/index.vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import VirtualWaterfall from '@xt/www/components/virtualWaterFall/index.vue'
import { EnumTongHaoStatus } from '@xt/client/enums/kindred-spirit'
import { DairyOption, HomeworkOption } from '@xt/client/entities/course-v2/user-content'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import ConfirmModal from './components/ConfirmModal/index.vue'
import InitConfirmModal from './components/InitConfirmModal/index.vue'
import CongratulateModal, { CongratulateType, type CongratulateModalData } from './components/CongratulateModal/index.vue'
import type { ConfirmModalOptions, Moment, ModalDataType } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { Bind, Debounce } from 'lodash-decorators'
import lodash from 'lodash'
import HeaderPanel from './components/HeaderPanel/index.vue'
import IntroPanel from './components/IntroPanel/index.vue'
import CityListGird from './components/CityListGird/index.vue'

type QueryParams = {
  active: string
}

@Observer
@Component({
  components: {
    MomentCard,
    InfiniteLoading,
    UserContentPop,
    VirtualWaterfall,
    ConfirmModal,
    HeaderPanel,
    IntroPanel,
    CityListGird,
    InitConfirmModal,
    CongratulateModal
  },
  async asyncData(ctx) {
    const queryParams = ctx.store.$tonghao.formatQuery(ctx.query)
    await ctx.store.$tonghao.loadJSON()

    let hasJoin: boolean = false

    if (ctx.store.$storeUser.UserInfo.id) {
      hasJoin = await ctx.store.$tonghao.Guild.getHasJoinedCity()
    }

    return {
      queryParams,
      hasJoin
    }
  }
})
export default class TonghaoPage extends Vue {
  queryParams: QueryParams

  requestTime: number = Date.now()
  needLogin: boolean = false

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  get EnumTongHaoStatus() {
    return EnumTongHaoStatus
  }

  get bodyParams() {
    let params: string[] = []
    Object.entries(this.queryParams).forEach(([key, value]) => {
      let title: string = ''

      if (key === 'active' && value !== '') {
        title = this.tabs.filter(el => el.key === value)[0]?.title
      }

      if (title) {
        // 排除1，塞入其他选项
        // 1202 - ‘推荐’ 移除 ‘同学作品（7）’
        if (value === EnumTongHaoStatus.Discover || value === EnumTongHaoStatus.Follow) {
          params = this.tabs
            .filter(
              el =>
                !(
                  el.key === EnumTongHaoStatus.Follow ||
                  el.key === EnumTongHaoStatus.Discover ||
                  el.key === EnumTongHaoStatus.ClassmateWork
                )
            )
            .map(el => el.title)
        } else {
          params.push(title)
        }
      }
    })

    return params.join(',')
  }

  get body() {
    console.log('bodyParams', this.bodyParams)

    return {
      firstRequestTime: this.requestTime,
      topics: this.queryParams.active === EnumTongHaoStatus.Follow ? undefined : this.bodyParams, // 关注页不传topics参数
      active: this.queryParams.active
    }
  }

  get pagePagination() {
    return this.PageStore.pagePagination
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  get PageStore() {
    return this.$store.$tonghao
  }

  get tabs() {
    return dataSource_tonghaoV2
  }

  // 获取动态高度
  getComptedHeightList(list) {
    return this.toJS(list).map(item => {
      let totalHeight: number = 0

      // 计算图片高度
      totalHeight +=
        Array.isArray(this.toJS(item.pictures)) && item.pictures.length > 0
          ? this.getImageHeight(item.pictures[0].originWidth, item.pictures[0].originHeight)
          : 248
      // 计算 title 间距
      totalHeight += item.sourceDescription ? 8 : 10
      // 计算 title 高度，如果超过200（一行文字宽度），则高度为36，否则为18
      totalHeight += (this.getTextWidth(item.title || item.content) ?? 0) > 200 ? 36 : 18
      // 计算 card-info 间距 + 高度 + 底部间距
      totalHeight += 12 + 28 + 12

      return {
        ...item,
        height: totalHeight
      }
    })
  }

  getTextWidth(text, font = '14px sans-serif') {
    if (!text) return null
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) return null
    ctx.font = font
    return ctx.measureText(text).width
  }

  compactImageSize(originWidth: number, originHeight: number) {
    const limitWidth = 194
    const shouldHeigth = Math.floor((limitWidth * originHeight) / originWidth)

    return [limitWidth, shouldHeigth]
  }

  getImageHeight(originWidth: number, originHeight: number) {
    return Math.max(100, Math.min(248, this.compactImageSize(originWidth, originHeight)[1]))
  }

  handleClosed() {
    if (this.needLogin) {
      this.$store.$storeUser.onToggleVisible(true)
      this.needLogin = false
    }
  }

  handleOpenLogin() {
    this.needLogin = true
    this.userContentPop.hidePop()
  }

  // 弹窗内部删除事件
  handleRemoveSuccess(data: { type: 'dairy'; momentId: string }) {
    if (data.type === 'dairy' && data.momentId) {
      // 删除缓存的数据
      this.PageStore.removeItem(data.momentId)
    }
  }

  // 弹窗内部收藏事件
  handleLikeSuccess(data: { momentId: string }) {
    if (data.momentId) {
      this.PageStore.likeItem(data.momentId)
    }
  }

  // 卡片点击事件
  handleClickMoment(momentId: string) {
    if (!momentId) return

    this.userContentPop?.showPop({
      type: 'dairy',
      momentId
    })
  }

  // 卡片点赞事件
  @Debounce(350, { leading: true, trailing: false })
  @Bind()
  async handleLikeMoment(item: Moment) {
    // 未登录防御
    if (!this.UserInfo.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    try {
      await this.PageStore.onLikeMoment(item)
      this.$message.success('点赞成功')
    } catch (e) {
      if (e instanceof Error) {
        this.$message.error(e.message)
      }
    }
  }

  handleChangeTab(params: Partial<QueryParams>) {
    if (lodash.isEqual(this.queryParams, params)) return

    this.queryParams = {
      ...this.queryParams,
      ...params
    }

    this.PageStore.mapPagePagination(this.queryParams.active as EnumTongHaoStatus)

    // 切换tab数据清空 + 缓存
    this.PageStore.pagePagination.clearData(this.body)

    if (!lodash.isEqual(this.$route.query, this.PageStore.toSearchQuery(this.queryParams))) {
      this.$router.replace({ query: this.PageStore.toSearchQuery(this.queryParams) })
    }

    // 根据是否显示推荐城市模块，调整切换tab时的向上滚动距离
    window.scrollTo({
      top: !this.showRecommend === true ? 0 : 926,
      behavior: 'smooth'
    })
  }

  hideRecommendCities: boolean = false
  readonly hideCitiesStoreKey: string = 'hide-recommend-cities'
  hasJoin: boolean

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => Promise<boolean>
  }
  @Ref()
  initConfirmModal: {
    show: (options?: ConfirmModalOptions) => void
  }
  @Ref()
  congratulateModal: {
    show: (options?: CongratulateModalData) => void
  }

  get showIntroPanel() {
    return this.hasJoin && this.queryParams.active === EnumTongHaoStatus.FenTong
  }

  get showRecommend() {
    return !this.hideRecommendCities && !this.hasJoin
  }

  get GuildStore() {
    return this.$store.$tonghao.Guild
  }
  get TabList() {
    const isLogin = !!this.UserInfo.id
    const { Follow, FenTong } = EnumTongHaoStatus

    return this.tabs.filter(item => {
      // 未登录不显示 - 关注
      if (!isLogin) return ![Follow, FenTong].includes(item.key as EnumTongHaoStatus)
      // 已登录，关闭分桐的情况下则显示；未关闭不显示 - 分桐
      return this.hasJoin === true || item.key !== FenTong || this.hideRecommendCities
    })
  }

  checkShowRecommendCities() {
    if (!this.UserInfo.id) return

    if (!!localStorage.getItem(this.hideCitiesStoreKey) === true) {
      this.hideRecommendCities = true
    }
  }
  handleHideRecommendCities() {
    if (!this.UserInfo.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    this.hideRecommendCities = true

    localStorage.setItem(this.hideCitiesStoreKey, 'true')
  }

  // 完善个人信息弹窗
  openImproveModal() {
    this.confirmModal.show({
      title: `完善个人信息`,
      description: `・填写手机号，方便分桐负责人联络\n・简单介绍自己，聊聊你的兴趣爱好吧~`,
      layoutClassName: 'improve-confirm-modal',
      confirmedHide: true,
      confirmText: '去完善',
      cancelText: '取消',
      onOk: () => {
        this.$msg('敬请期待~')
      }
    })
  }

  onJoinSuccess() {
    this.$msg('加入成功~', 'success')
    setTimeout(() => {
      location.reload()
    }, 200)
  }
  async openAssistantModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `为${data.cityName}分桐助力`,
      description: '助力后将自动加入该分桐，并增加分桐热力值。达到目标后可推进分桐开放。',
      layoutClassName: 'assistant-confirm-modal',
      confirmedHide: true,
      confirmText: '立即助力',
      cancelText: '稍后再说',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/assistant-pop-bg.png'
    })
    if (res === true) {
      const res = await this.GuildStore.joinGuild(data.id)
      if (res === true) {
        this.onJoinSuccess()
      }
    }
  }
  async openRecruitModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `成为${data.cityName}分桐负责人`,
      description: `报名参与负责人招募，即视为您已自动加入该分桐。待负责人招募工作全部完成后，${data.cityName}分桐将正式开放。`,
      layoutClassName: 'recruit-confirm-modal',
      confirmedHide: true,
      confirmText: '确认',
      cancelText: '再想想',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/recruit-pop-bg.png'
    })

    if (res === true) {
      const res = await this.GuildStore.joinGuild(data.id)
      if (res === true) {
        this.onJoinSuccess()
      }
    }
  }
  async openJoinModal(data: ModalDataType) {
    const res = await this.confirmModal.show({
      title: `${data.cityName}分桐`,
      description: '桐学仅可选择一座常住城市加入，与桐好笔墨相伴，雅会常聚。',
      layoutClassName: 'join-confirm-modal',
      confirmedHide: true,
      confirmText: '确认加入',
      cancelText: '再想想',
      backgroundUrl: this.$store.$global.static + '/images/topic/pc/assistant-pop-bg.png'
    })

    if (res === true) {
      const res = await this.GuildStore.joinGuild(data.id)
      if (res === true) {
        this.onJoinSuccess()
      }
    }
  }

  openInitModal() {
    this.initConfirmModal.show()
  }
  handleInitSelect() {}

  showCongratulateModal(data: ModalDataType) {
    // this.congratulateModal.show({
    //   type: CongratulateType.Init,
    //   bgPath: 'congratulate-init',
    //   cityName: data.cityName
    // })

    this.congratulateModal.show({
      type: CongratulateType.Recruit,
      bgPath: 'congratulate-recruit',
      cityName: data.cityName
    })
  }
  async initCities() {
    if (this.UserStore.LocationInfo) {
      this.PageStore.Guild.getLocateRecommendCities(this.toJS(this.UserStore.LocationInfo!.cityCode).toString())
    }
    this.PageStore.Guild.getRecommendCities()
  }
  async initLocation() {
    if (!this.UserInfo.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    await this.UserStore.initUserLocation()

    this.initCities()
  }

  init() {
    this.checkShowRecommendCities()

    this.initCities()
  }

  created(): void {
    this.PageStore.mapPagePagination(this.queryParams.active as EnumTongHaoStatus)
    this.init()
  }

  mounted() {}

  updated(): void {}

  destroyed(): void {}
}
